export default __webpack_public_path__ + "static/media/Stage2_title.92ce4164.png";